<div class="journey-details-dialog" *transloco="let t; prefix: 'widgets.journey.journey-details'">
  <div class="journey-details-dialog__header">
    <h2 class="journey-details-dialog__title">{{ t('title') }}</h2>
    @if (activeChannelFilter()) {
      <span class="journey-details-dialog__channel-badge">
        {{ t('channel-filter', { channel: activeChannelFilter()?.label }) }}
      </span>
    }
  </div>

  <div class="journey-details-dialog__panels">
    <as-split direction="horizontal" class="journey-details-dialog__split">
      <as-split-area [size]="46" [minSize]="28">
        <div class="journey-details-dialog__left">
          <div class="journey-details-dialog__search">
            <xi-search-box
              [placeholder]="t('search-placeholder')"
              [isFiredOnEnter]="false"
              (onChangeOverride)="onSearchChanged($any($event).detail.searchText)"
              (onCancelClick)="onSearchChanged('')"
            ></xi-search-box>
          </div>

          <div class="journey-details-dialog__body">
            <div class="journey-details-dialog__section-header">
              {{
                t('touchpoints-label', {
                  subjectId: options().subjectId,
                  count: displayTouchpointCount(),
                })
              }}
            </div>

            @if (isLoading()) {
              <div class="journey-details-dialog__loading">
                <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
              </div>
            } @else if (displayTouchpoints().length === 0) {
              <div class="journey-details-dialog__empty">
                {{ t('no-touchpoints') }}
              </div>
            } @else {
              <div class="journey-details-dialog__list">
                @for (tp of displayTouchpoints(); track trackTouchpoints(tp.document)) {
                  <div
                    class="journey-details-dialog__touchpoint"
                    [class.journey-details-dialog__touchpoint--clickable]="true"
                    (click)="openDocument(tp)"
                  >
                    <div class="journey-details-dialog__touchpoint-header">
                      <div
                        class="journey-details-dialog__channel-icon"
                        [class.journey-details-dialog__channel-icon--clickable]="true"
                        (click)="onChannelClick($event, tp)"
                      >
                        <mat-icon fontSet="kitchen-icons" [fontIcon]="tp.channelIcon"></mat-icon>
                      </div>
                      <span
                        class="journey-details-dialog__channel-label"
                        [class.journey-details-dialog__channel-label--clickable]="true"
                        (click)="onChannelClick($event, tp)"
                        >{{ tp.channelLabel }}</span
                      >
                      @if (tp.timestamp) {
                        <span class="journey-details-dialog__timestamp">
                          {{ tp.timestamp | date: "MM/dd/yyyy 'at' h:mm a" }}
                        </span>
                      }
                    </div>

                    <p class="journey-details-dialog__summary">{{ tp.displaySummary }}</p>

                    @if (tp.metadataValues.length > 0) {
                      <div class="journey-details-dialog__metadata-list">
                        @for (meta of tp.metadataValues; track $index) {
                          <div class="journey-details-dialog__metadata-item">
                            <span class="journey-details-dialog__metadata-label"
                              >{{ meta.label }}:</span
                            >
                            <span
                              class="journey-details-dialog__metadata-value"
                              [class.journey-details-dialog__metadata-value--positive]="
                                meta.isPositive
                              "
                              [class.journey-details-dialog__metadata-value--negative]="
                                meta.isNegative
                              "
                              >{{ meta.displayValue }}</span
                            >
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </as-split-area>

      <as-split-area [size]="54" [minSize]="24">
        <div class="journey-details-dialog__right">
          <div class="journey-details-dialog__nlp-header">
            <mat-icon fontSet="kitchen-icons" fontIcon="kxi-icon-feedback"></mat-icon>
            <span>{{ t('nlp-overview-title') }}</span>
          </div>

          <button
            type="button"
            class="journey-details-dialog__nlp-controls-toggle"
            (click)="onNlpControlsToggled()"
          >
            <span class="journey-details-dialog__nlp-controls-toggle-label">{{
              t('nlp-settings')
            }}</span>
            <mat-icon
              fontSet="kitchen-icons"
              [fontIcon]="nlpControlsCollapsed() ? 'kxi-icon-chevron_down' : 'kxi-icon-chevron_up'"
            ></mat-icon>
          </button>

          @if (!nlpControlsCollapsed()) {
            <div class="journey-details-dialog__nlp-settings">
              <div
                class="journey-details-dialog__nlp-controls journey-details-dialog__nlp-controls--show-row"
              >
                <span class="journey-details-dialog__nlp-controls-label">{{ t('nlp-show') }}</span>
                <xi-dropdown
                  class="journey-details-dialog__nlp-select"
                  select="single"
                  [value]="nlpDirection()"
                  [data]="nlpDirectionOptions()"
                  (onValueChange)="onNlpDirectionChanged($any($event).detail.selected.id)"
                ></xi-dropdown>
                <xi-input-field
                  class="journey-details-dialog__nlp-number"
                  type="number"
                  [min]="1"
                  [max]="50"
                  [step]="1"
                  [ngModel]="nlpLimit()"
                  (ngModelChange)="onNlpLimitChanged($event)"
                  appOnlyDigit
                ></xi-input-field>
                <span class="journey-details-dialog__nlp-controls-label">{{
                  t('nlp-results')
                }}</span>
              </div>
              <div class="journey-details-dialog__nlp-sentiment-row">
                <span class="journey-details-dialog__nlp-controls-label"
                  >{{ t('nlp-sentiment-label') }}:</span
                >
                <xi-dropdown
                  class="journey-details-dialog__nlp-select"
                  select="single"
                  [value]="nlpSentiment()"
                  [data]="nlpSentimentOptions()"
                  (onValueChange)="onNlpSentimentChanged($any($event).detail.selected.id)"
                ></xi-dropdown>
              </div>
            </div>

            <div class="journey-details-dialog__nlp-filters">
              <span class="journey-details-dialog__nlp-filters-label">{{ t('nlp-filters') }}</span>
              <div class="journey-details-dialog__nlp-chips">
                @if (activeChannelFilter()) {
                  <span class="journey-details-dialog__nlp-chip">
                    {{ t('channel-filter', { channel: activeChannelFilter()?.label }) }}
                    <xi-icon-button
                      class="journey-details-dialog__nlp-chip-remove"
                      icon="cancel"
                      iconSize="small"
                      (onClick)="onChannelFilterRemoved()"
                    ></xi-icon-button>
                  </span>
                }
                @if (nlpActiveFilter()) {
                  <span
                    class="journey-details-dialog__nlp-chip journey-details-dialog__nlp-chip--active"
                  >
                    {{ nlpActiveFilter()!.name }}
                    <xi-icon-button
                      class="journey-details-dialog__nlp-chip-remove"
                      icon="cancel"
                      iconSize="small"
                      (onClick)="onNlpFilterRemoved()"
                    ></xi-icon-button>
                  </span>
                }
                @if (!activeChannelFilter() && !nlpActiveFilter()) {
                  <span class="journey-details-dialog__nlp-no-filters">{{
                    t('nlp-no-filters')
                  }}</span>
                }
              </div>
            </div>
          }

          <div class="journey-details-dialog__nlp-output">
            <app-document-nlp-output
              [options]="journeyNlpOptions()"
              [document]="journeyNlpDocument()"
              [closedGroups]="nlpClosedGroups()"
              [showHeader]="false"
              interactionMode="journey"
              (closedGroupsChange)="onNlpClosedGroupsChange($event)"
              (analyticItemSelected)="onJourneyNlpSelection($event)"
            ></app-document-nlp-output>
          </div>
        </div>
      </as-split-area>
    </as-split>
  </div>
</div>

@if (showDocumentView()) {
  <app-lex-xi-modal
    [isVisible]="showDocumentView()"
    [canBackdropClose]="false"
    maxWidth="80vw"
    (close)="onDocumentViewClosed($event)"
  >
    <ng-template appXIModalContent>
      @if (showDocumentView() && documentViewOptions()) {
        <app-document-view-dialog
          [options]="documentViewOptions()!"
          (modalClosed)="onDocumentViewClosed($event)"
        ></app-document-view-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
